import { httpClient } from "@/services";

export default {
	state: {
		settings: [],
		services: []
	},
	getters: {
		getAccountingSettings(state) {
			return state.settings;
		},
		getAccountingServices(state) {
			return state.services;
		}
	},
	mutations: {
		SET_SETTINGS_ACCOUNTING(state, payload) {
			state.settings = payload;
		},
		SET_SERVICES_ACCOUNTING(state, payload) {
			state.services = payload;
		},
		ADD_SERVICE(state) {
			state.services.push({
				status: 1,
				id: null,
				name: 'Name'
			});
		}
	},
	actions: {
		async onFetchAccountingSettings({ commit }) {
			try {
				const { data } = await httpClient.get('/settings/account');
				if (data) {
					const { setting, service } = data;
					if (setting) {
						commit('SET_SETTINGS_ACCOUNTING', setting);
						commit('SET_SERVICES_ACCOUNTING', service);
					}
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onFetchSaveSettingsAccounting({ commit }, payload) {
			try {
				const { data } = await httpClient.post('/settings/account', payload);
				const { status, setting } = data;
				if (status) {
					commit('SET_SETTINGS_ACCOUNTING', setting);
					return status;
				}
			} catch (e) {
				console.error(e);
			}
		}
	}
};
